<div class="call-detail" *ngIf="item">
  <div class="detail-left">
    <div class="call-overview">
      <div class="ai-score-tile">
        <div class="ai-score-value" [ngClass]="item.AiScore != null ? scoreClass(item.AiScore) : ''">{{ item.AiScore ?? '-' }}</div>
        <div class="ai-score-label">AI Score</div>
      </div>

      <div class="call-facts">
        <div class="pill-list" *ngIf="item.CallCategories?.length">
          <span class="dot-pill category-pill" *ngFor="let category of item.CallCategories"><span class="dot"></span>{{ category.Name }}</span>
        </div>
        <div class="pill-list" *ngIf="item.CallTags?.length">
          <span class="dot-pill tag-pill" *ngFor="let tag of item.CallTags"><span class="dot"></span>{{ tag.Name }}</span>
        </div>
        <div class="direction">
          <span class="direction-arrow" aria-hidden="true">{{ directionArrow(item.Direction) }}</span>{{ item.Direction }}
        </div>
        <div class="date-duration">
          <span>{{ formatDateTime(item.CallDateTime) }}</span>
          <span>{{ formatDuration(item.Duration) }}</span>
        </div>
        <div *ngIf="item.AiSentiment">
          <span class="dot-pill" [ngClass]="sentimentClass(item.AiSentiment)"><span class="dot"></span>{{ item.AiSentiment }}</span>
        </div>
        <div class="fact-line"><span class="fact-label">Employee / Agent:</span> {{ item.EmployeeName || '-' }}</div>
        <div class="fact-line"><span class="fact-label">Caller ID:</span> {{ formatCallerId(item.PhoneNumber) }}</div>
      </div>
    </div>

    <div class="audio-card">
      <ng-container *ngIf="audioUrl; else noRecording">
        <audio #audioPlayer [src]="audioUrl" (play)="onAudioPlay()" (pause)="onAudioPause()" (ended)="onAudioPause()"
          (loadedmetadata)="onLoadedMetadata()" (timeupdate)="onTimeUpdate()"></audio>
        <button type="button" class="play-btn" (click)="togglePlay()" [attr.aria-label]="isPlaying ? 'Pause' : 'Play'">
          <i class="fa" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
        </button>
        <div class="audio-progress">
          <div class="progress-track" #progressTrack (click)="seekAudio($event, progressTrack)" (keydown)="onSeekKeydown($event)"
            role="slider" tabindex="0" aria-label="Playback position" aria-valuemin="0"
            [attr.aria-valuemax]="audioDuration" [attr.aria-valuenow]="audioCurrentTime"
            [attr.aria-valuetext]="formatDuration(audioCurrentTime) + ' of ' + formatDuration(audioDuration)">
            <div class="progress-fill" [style.width.%]="audioProgressPercent"></div>
          </div>
          <div class="audio-times">
            <span>{{ formatDuration(audioCurrentTime) }}</span>
            <span>{{ formatDuration(audioDuration) }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #noRecording>
        <span class="text-muted">{{ summary?.DataExpired ? 'Recording has expired.' : 'Recording not available.' }}</span>
      </ng-template>
    </div>

    <div class="section-title">AI Summary</div>
    <div class="summary-card">{{ summary?.AiSummary || 'AI summary not available for this call.' }}</div>
  </div>

  <!-- Spec image-170: agent on the left, caller on the right. -->
  <div class="detail-right">
    <div class="section-title">Call Transcript</div>
    <div *ngIf="transcriptLoading" class="text-muted">Loading transcript&hellip;</div>
    <div *ngIf="!transcriptLoading && !transcriptTurns.length" class="text-muted">Transcript not available for this call.</div>
    <div class="transcript-turn" *ngFor="let turn of transcriptTurns; trackBy: trackByIndex" [class.customer-turn]="turn.isCaller">
      <div class="turn-speaker">{{ turn.name }}</div>
      <div class="turn-bubble">{{ turn.text }}</div>
    </div>
  </div>
</div>
